import "babel-polyfill";
import "./libs/jcf/jcf.js";
import "./libs/jcf/jcf.scrollable.js";
import "./libs/jcf/jcf.select.js"; /*custom code (add first-disabled class)*/
import "./plugins/breaking-news-ticker.min.js";
import {binder, fwa} from "./libs/binder";
import {
  constants,
  headerFunction
} from "./modules/module";
import {startAnimation} from "./modules/startAnimation";
import {videoPopup} from "./modules/videoPopup";
import {screening} from "./modules/screening";
import {customSelect} from "./modules/customSelect";
import {sectionCarousel} from "./modules/sectionCarousel";
import {videosSection} from "./modules/videosSection";
import {hereSection} from "./modules/hereSection";
import {statsSection} from "./modules/statsSection";
import {progressbar} from "./modules/progressbar";
import {trailerSection} from "./modules/trailerSection";
import {popup} from "./modules/popup";

binder({
  bounds: {
    "html": [constants, startAnimation],
    ".header": headerFunction,
    ".open-video": videoPopup,
    ".screening": screening,
    ".section-carousel": sectionCarousel,
    ".videos": videosSection,
    ".here-section": hereSection,
    ".stats-section": statsSection,
    ".progressbar": progressbar,
    ".trailer-section": trailerSection,
    ".open-popup": popup,
    "select": customSelect
  },
  runTests: false
});


(function () {
  window.initCustomForms = function () {
    customSelect();
  }
})();


// WEBPACK FOOTER //
// ./assets/js/global.js